import { FREQUENCY } from "../../constants/commonConstants";
import { REPAYMENT_AMOUNT } from "../../constants/paymentConstants";
import { isNotNullOrEmpty } from "./stringHelper";

const adjustRepaymentsToMatchFrequency = (frequency, repayments) => {
  if (frequency === FREQUENCY.FORTNIGHTLY) {
    return repayments.map((val) => val * 2);
  }

  if (frequency === FREQUENCY.MONTHLY) {
    return repayments.map((val) => Math.ceil((val * 52) / 12));
  }

  return repayments;
};

export const repaymentHelper = async (value, frequency) => {  //remove async when testing
  if (isNotNullOrEmpty(value) && isNotNullOrEmpty(frequency)) {
    if (value > 10000) {
      value = 10000;
    }

    const { repayment } = REPAYMENT_AMOUNT.find((obj) => obj.amount >= value)|| {repayment: []};

    return adjustRepaymentsToMatchFrequency(frequency, repayment);
  }
  return [];
};
